var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 330,
    height: 429,
    viewBox: "0 0 330 429",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-467.261 166.252C-503.705 123.055 -522.674 78.3293 -524.499 33.1831C-524.638 29.6506 -524.707 26.118 -524.707 22.5904C-524.707 -59.8749 -489.139 -115.07 -423.159 -149.158C-415.307 -353.773 -311.914 -429 -138.073 -429C42.8733 -429 231.557 -310.987 231.557 -86.9033C231.557 -86.3591 231.547 -85.8148 231.547 -85.2706C275.402 -49.2576 301.97 -4.55173 301.97 48.5699C301.97 93.815 288.879 140.455 254.024 184.924C302.064 219.448 326.95 255.47 329.103 291.879C329.251 294.417 329.32 296.956 329.32 299.494C329.32 413.776 172.142 428.05 -67.6346 428.05C-307.417 428.05 -539 395.109 -539 280.826C-539 242.637 -520.017 203.056 -467.261 166.252Z",
    fill: "#AFA2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCloud);
export default __webpack_public_path__ + "static/media/left-cloud.3a1421ad6c8c261ad51a72780034ac06.svg";
export { ForwardRef as ReactComponent };